<template>
  <v-card flat class="audio-container">
    <audio
      ref="audioPlayer"
      :src="src"
      :type="type"
      @play="onPlay"
      @pause="onPause"
      @timeupdate="onTimeUpdate"
      @loadedmetadata="onLoadedMetadata"
      loading="lazy"
    >
      مرورگر شما از فایل صوتی پشتیبانی نمی‌کند.
    </audio>

    <v-card flat class="controls">
      <v-btn small color="blue" @click="togglePlay" icon>
        <v-icon>{{ isPlaying ? "mdi-pause" : "mdi-play" }}</v-icon>
      </v-btn>
      <div class="coverprogress" v-if="big">
        <v-slider
          v-model="currentTime"
          :max="duration"
          step="0.1"
          color="blue"
          class="progress-slider"
          reverse
          @change="seek"
          hide-details
        ></v-slider>
        <!-- <div class="time-display">
          {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
        </div> -->
      </div>
      <div
        class="volume-container"
        @mouseenter="showVolumeSlider = true"
        @mouseleave="showVolumeSlider = false"
      >
        <v-btn small color="blue" icon @click="toggleMute">
          <v-icon>{{ isMuted ? "mdi-volume-off" : "mdi-volume-high" }}</v-icon>
        </v-btn>
        <div class="coverSlider">
          <v-slider
            v-model="volume"
            min="0"
            max="1"
            step="0.1"
            color="blue"
            class="volume-slider"
            @input="updateVolume"
            reverse
            hide-details
          ></v-slider>
        </div>
      </div>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "MediaPlayer",
  props: {
    src: String,
    type: String,
    big: Boolean,
  },
  data() {
    return {
      volume: 1.0,
      currentTime: 0,
      duration: 0,
      isPlaying: false,
      isMuted: false,
      previousVolume: 1.0,
      showVolumeSlider: false,
    };
  },
  methods: {
    togglePlay() {
      const audio = this.$refs.audioPlayer;
      this.isPlaying ? audio.pause() : audio.play();
    },
    updateVolume(newVolume) {
      this.volume = newVolume;
      this.$refs.audioPlayer.volume = this.volume;
      this.isMuted = this.volume === 0;
    },
    toggleMute() {
      this.isMuted = !this.isMuted;
      if (this.isMuted) {
        this.previousVolume = this.volume;
        this.volume = 0;
      } else {
        this.volume = this.previousVolume;
      }
      this.$refs.audioPlayer.volume = this.volume;
    },
    seek(newTime) {
      this.$refs.audioPlayer.currentTime = newTime;
    },
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    onTimeUpdate(event) {
      this.currentTime = event.target.currentTime;
    },
    onLoadedMetadata(event) {
      this.duration = event.target.duration;
    },
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}:${secs < 10 ? "0" + secs : secs}`;
    },
  },
};
</script>

<style scoped>
.audio-container {
  width: 100%;
  max-width: 300px;
}
.controls {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  padding: 1px;
  direction: ltr;
  /* padding-bottom: 25px;
  padding-top: 25px; */
}
.volume-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.volume-slider {
  /* position: absolute; */
  /* bottom: calc(100% + 5px); */
  left: 50%;
  height: 1px;
  width: 60px;
  background-color: rgba(234, 234, 255, 0.9);
  border-radius: 5px;
  transition: opacity 0.3s ease;
  z-index: 100;
  transform: translateX(60%) rotate(180deg);
}
.volume-container:hover .volume-slider {
  opacity: 1;
}
.volume-slider:not(:hover) {
  opacity: 0;
}
.coverprogress {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.progress-slider {
  width: 100%;
  transform: rotate(180deg);
}
.time-display {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}
.v-slider__thumb-label {
  font-size: 8px;
}
.coverSlider {
  width: 60px;
}
</style>
